import React, { useContext } from "react";
import { AuthContext } from "@context/AuthContext";
import AlertMessage from "@components/AlertMessage";

const LoginFormAlerts = ({ loginError, successMessage, showError, displayEmail = false }) => {
    const { unverifiedEmailToken, resendAccountCreation } = useContext(AuthContext);

    const errorContent = unverifiedEmailToken ? (
        <p className="alert-message__text">
            Please verify your email, click the link in the email we sent you to complete signup.
            Still can&apos;t find the email, click{" "}
            <button
                type="button"
                className="link link__button link__clickable"
                onClick={() => resendAccountCreation(unverifiedEmailToken)}
            >
                here
            </button>{" "}
            to resend.
        </p>
    ) : loginError;

    return (
        <>
            {successMessage && <AlertMessage message={successMessage} type="success" />}
            {showError && (
                <AlertMessage message={errorContent} type="error" displayEmail={displayEmail} />
            )}
        </>
    );
};

export default LoginFormAlerts;
